import { useSubscription } from '@rta/rta-blueprint-library';

import { Controller } from '@context';
import { lang } from '@lang';
import { useDesign } from '@hooks';
import { Feature, FeatureHoookParams } from '..';

type ObstructionFeatureParams = FeatureHoookParams;
export const useShowObstructionFeature = (_params: ObstructionFeatureParams = {}): Feature<boolean> => {
	const [controller] = useDesign<Controller, { options: { showObstructions: boolean }}>();

	useSubscription(controller, false, [['layer-option-obstruction', '*']]);

	const controllerSupportsFeature = (controller?.options?.showObstructions ?? null) !== null;
	const showLayer = controller?.options?.showObstructions ?? true;

	const tooltip = (() => {
		const showHide = showLayer ? lang.layer.tooltip.hide : lang.layer.tooltip.show;
		return `${showHide} ${lang.layer.label.obstructions} ${lang.layer.layer}`;
	})();

	return {
		name: 'showObstruction',
		label: lang.layer.label.obstructions,
		shortcut: '',
		tooltip,
		icon: (props = {}) => <></>,
		disabled: !controllerSupportsFeature,
		value: showLayer,
		hidden: false,
		handler: () => {
			if (controller) {
				controller.options.showObstructions = !showLayer;
			}
		}
	};
};
